module.exports = __webpack_public_path__ + "static/img/item_image_123.f3913e08.png";